import { Maybe } from 'maybeasy';
import { LearningDesign } from '../../Types/SectionTemplates';
import { ExperienceResource } from '../../Types';
import { CombinedExperience } from './useFetchMultipleExperienceDetails';
import TabNavigation, { TabType } from './TabNavigation';
import ProgramsTab from './ProgramsTab';
import SchoolPartnersTab from './SchoolPartnersTab';
import CompetenciesTab from './CompetenciesTab';

interface Props {
  section: LearningDesign;
  activeTab: TabType;
  onTabChange: (tab: TabType) => void;
  basicExperiences: ExperienceResource[];
  combinedExperiences: CombinedExperience[];
  loadingDetails: boolean;
  detailsError: Maybe<string>;
  activeCompetencyId: Maybe<number>;
  onCompetencyClick: (id: number) => void;
}

const DetailView: React.FC<Props> = ({
  section,
  activeTab,
  onTabChange,
  basicExperiences,
  combinedExperiences,
  loadingDetails,
  detailsError,
  activeCompetencyId,
  onCompetencyClick,
}) => {
  const tabMetadata = {
    programsCount: section.experiences.length,
    schoolPartnersCount: section.school_partners.length,
    competenciesCount: section.competencies.length,
  };

  return (
    <div
      className="flex flex-col flex-1 space-y-4 overflow-hidden"
      data-intercom-target="curated-section-detail-view"
    >
      <div className="border-t pt-4">
        <TabNavigation activeTab={activeTab} onTabChange={onTabChange} metadata={tabMetadata} />

        <div className="mt-6 flex-1 overflow-y-auto">
          {/* Programs Tab Content */}
          <div className={activeTab === 'programs' ? 'block' : 'hidden'}>
            <ProgramsTab
              basicExperiences={basicExperiences}
              combinedExperiences={combinedExperiences}
              loadingDetails={loadingDetails}
              detailsError={detailsError}
              totalCount={section.experiences.length}
            />
          </div>

          {/* School Partners Tab Content */}
          <div className={activeTab === 'schoolPartners' ? 'block' : 'hidden'}>
            <SchoolPartnersTab schoolPartners={section.school_partners} />
          </div>

          {/* Competencies Tab Content */}
          <div className={activeTab === 'competencies' ? 'block' : 'hidden'}>
            <CompetenciesTab
              competencies={section.competencies}
              activeCompetencyId={activeCompetencyId}
              onCompetencyClick={onCompetencyClick}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default DetailView;
